<template>
    <div class="container-fluid">
      <bounce-loader :loading="loading"></bounce-loader>
      <iframe v-if="data" width="100%" height="100%" :src="data.cta_link_or_iframe_src"></iframe>      
      <div class="row" v-if="error">
        <div class="col-md-6">
          <h1 id="proy-code" class="pull-left">{{ codigo_proyecto }}</h1>
        </div>        
        <div class="col-xs-12 text-center">
          {{ error }}
        </div>
      </div>   
    </div>   
</template>
<script>
// import api from '../../../api'
// import { EventBus } from '../../core/event-bus.js'
export default {
  name: 'ProyectoIframe',
  props: ['codigo_proyecto', 'index'],
  data () {
    return {
      data: null,
      error: null,
      loading: true
    }
  },
  mounted () {
    let vm = this
    setTimeout(() => {
      let proyecto = vm.$store.getters.getProyectoPorCodigo(vm.codigo_proyecto)
      if (proyecto) {
        vm.data = proyecto.simaapplink[vm.index]
        vm.loading = false
      } else {
        vm.error = 'No existe el proyecto o el iframe'
        vm.loading = false
      }
    }, 1000)
  }
}
</script>
<style>
iframe {
  border: 1px solid #d2d6de;
}
</style>


// WEBPACK FOOTER //
// src/components/views/proyectos/Iframe.vue